import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import canna42 from "../assets/imgPlaceholder.png";
import btnStyles from "../styles/globalButtonStylng.module.css";
import styles from "../styles/menuAddSearchListItem.module.css";
import { isBrand, isProduct } from "../typeHelpers/typeCheck";
import { VenueInstance } from "../utils/venueClass";
import { MenuAddProductFromBrandListModal } from "./menuAddProductFromBrandListModal";
export const MenuAddSearchListItem = ({
  item,
  type,
  isOwned,
  handleAddMenuItem,
}: {
  item: Brand | Product;
  type: "brand" | "product" | undefined;
  isOwned: boolean;
  handleAddMenuItem: Function;
}) => {
  //console.log("item", item, isOwned, type);
  //products from active Venue
  const { products } = useSelector((state: any) => state.product);
  const { activeBusiness } = useSelector((state: any) => state.business);
  const [menuItems, setMenuItems] = useState<Product[]>([]);
  const [imageSrc, setImageSrc] = useState<string>(item.avatarUrl || canna42);
  const [formOpen, setFormOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<Brand | null>();

  const PG = "#00b894";
  const BG = "#d35400";
  const borderColor = type === "product" ? PG : BG;

  useEffect(() => {
    fetchMenuProducts();
  }, []);
  //fetch product asynchronously
  const fetchMenuProducts = async () => {
    try {
      console.log("fetching menu products");
      const temp = await VenueInstance.getMenu(activeBusiness.id.toString());
      if (temp !== undefined) {
        setMenuItems(temp);
      }
    } catch (error) {
      console.error("failed to get menu from venue");
    }
  };

  // Function to handle the image error
  const handleImageError = () => {
    setImageSrc(canna42); // Set the source to the default image on error
  };
  const handleFormButtonClick = () => {
    setFormOpen(!formOpen);
  };
  // Function to handle opening brand products modal
  const handleOpenBrandModal = (item: Brand | Product) => {
    if (isBrand(item)) {
      setSelectedBrand(item);
      setFormOpen(true);
    }
  };

  return (
    <div style={{ border: `1px solid ${borderColor}` }} className={`${styles.wrapper} ${type === "brand"}`}>
      <div className={styles.innerWrapper}>
        {/* image and name wrapper  */}
        <div className={styles.topWrapper}>
          {/* image wrapper */}
          <div className={styles.imageWrapper}>
            <img
              src={imageSrc}
              alt={item.name}
              style={{
                width: "100%",
                maxHeight: "100%",
                minHeight: "100%",
              }}
              onError={handleImageError}
            />
          </div>
          {/* name and info */}
          <div className={styles.nameWrapper}>
            <h4>{item.name}</h4>
            {type === "brand" ? (
              <p>{isBrand(item) ? item.tagLine : "Unknown Tag Line"}</p>
            ) : (
              <p>{isProduct(item) ? item?.brand.name : "Unknown Brand"}</p>
            )}
          </div>
        </div>
        {/* button */}
        <div className={styles.addWrapper}>
          {type === "brand" && (
            <button className={btnStyles.Basic} onClick={() => handleOpenBrandModal(item)}>
              View Products
            </button>
          )}
          {type === "product" &&
            (isOwned ? (
              <p>In Menu Already</p>
            ) : (
              <button className={btnStyles.Basic} onClick={() => handleAddMenuItem(item)}>
                Add Product
              </button>
            ))}
        </div>
      </div>
      <Modal show={formOpen} onHide={handleFormButtonClick} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Select Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MenuAddProductFromBrandListModal
            brandSelected={selectedBrand}
            closeModal={handleFormButtonClick}
            fetchMenuProducts={fetchMenuProducts}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
